import axios from "axios";
import { toast } from "react-toastify";
import { client, client_dp } from "../App";

import {
  ACTIVE_SUBSCRIPTION_KEY,
  DOMAIN,
  REST_API_SIGN_IN_URL,
} from "../constant";
import { GET_USER, GET_ALL_MODELS, GET_ALL_EDITORS } from "./user.queries";
import { getToken } from "../utilities/utilsFunction";

export const LoginUser = (data) =>
  new Promise((resolve, reject) => {
    var config = {
      method: "post",
      url: REST_API_SIGN_IN_URL,
      headers: {
        "Content-Type": "application/json",
        version: "v1",
        "Ocp-Apim-Subscription-Key": ACTIVE_SUBSCRIPTION_KEY,
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject("Please Check Login Credentials");
          toast.error("Please Check Login Credentials", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message ?? error?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        reject(error);
      });
  });

export const GetUser = (variable) =>
  new Promise((resolve, reject) => {
    client
      .query({
        query: GET_USER,
        variables: variable,
        fetchPolicy: "no-cache",
      })
      .then(({ data }) => {
        if (data.getUser) {
          resolve(data.getUser);
        } else {
          reject("Invalid Request");
        }
      })
      .catch(reject);
  });

export const GetAllEditors = (variable) =>
  new Promise((resolve, reject) => {
    client
      .query({
        query: GET_ALL_EDITORS,
        variables: variable,
        fetchPolicy: "no-cache",
      })
      .then(({ data }) => {
        if (data.findUsersByUserRole) {
          resolve(data.findUsersByUserRole);
        } else {
          reject("Invalid Request");
        }
      })
      .catch(reject);
  });

// Get All Machine Models
export const GetAllModels = () =>
  new Promise((resolve, reject) => {
    client_dp
      .query({
        query: GET_ALL_MODELS,
        variables: {},
        fetchPolicy: "no-cache",
      })
      .then(({ data }) => {
        if (data?.getModelMasters) {
          resolve(data?.getModelMasters);
        } else {
          reject("Invalid Request");
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

// Add Editor
export const AddEditor = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "POST",
      url: `${DOMAIN}/gatewayag/api/register`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
        "Ocp-Apim-Subscription-Key": ACTIVE_SUBSCRIPTION_KEY,
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Update Editor
export const UpdateEditor = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "PUT",
      url: `${DOMAIN}/gatewayag/api/updateuserdtl`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
        "Ocp-Apim-Subscription-Key": ACTIVE_SUBSCRIPTION_KEY,
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
